import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

//Hide GSAP warnings
gsap.config({ nullTargetWarn: false })

function revealHeaderCenteredElements() {

  const headerCenteredBlocks = Array.from(document.querySelectorAll('.js-header-centered'))

  headerCenteredBlocks.forEach(headerCenteredBlock => {

    const logoElement = headerCenteredBlock.querySelector('.js-logo')
    const tagElement = headerCenteredBlock.querySelector('.js-name-tag')
    const textElements = Array.from(headerCenteredBlock.querySelectorAll('.js-header-centered-content > *'))

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: headerCenteredBlock,
      },
    })

    tl.to(logoElement, {
        autoAlpha: 1,
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: .4,
      })
      .to(tagElement, {
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: .4,
      },
        '-=0.2'
      )
      .to(textElements, {
        autoAlpha: 1,
        duration: 1.6,
        stagger: .8,
      })
  })

}
revealHeaderCenteredElements()
